import { Input } from '@angular/core';
import { RestComponent } from './lib/RestComponent';
import { BitrixSortProps } from './lib/BitrixSortProperties';
import { CartService } from './cart/cart.service';
import { CompareService } from './compare/compare.service';
import { ConsultService } from './consult.service';
import { CatalogItem } from './catalog/catalog.service';

export let defaultNavParams = {
  iNumPage: 1,
  nPageSize: 12,
  checkOutOfRange: true
};

export let defaultOrder: BitrixSortProps = {
  SORT: 'ASC',
  catalog_PRICE_1: 'ASC'
};

export abstract class CatalogItemsDefaultComponent extends RestComponent {
  @Input() items: CatalogItem[] = [];
  @Input() isCatalogReady: boolean;
  placeLoaders: any[] = [];

  constructor(
    protected cartService: CartService,
    protected compareService: CompareService,
    protected consult: ConsultService,
  ) {
    super();
    this.placeLoaders.length = defaultNavParams.nPageSize;
    this.placeLoaders.fill('');
  }

  public async addToCart(item: CatalogItem) {
    if (!item.OFFERS && !item.CAN_BUY) return false;
    if (item.OFFERS && !item.OFFERS[0].PRICE.PRICE.CAN_BUY) return false;
    this.loadingState = true;

    const idProduct = item.OFFERS ? item.OFFERS[0].ID : item.ID;

    try {
      let quantity = 1;
      if (this.cartService.cart) {
        const existItem = this.cartService.cart.ITEMS.find((i) => `${i.OFFER_ID}` === idProduct);
        if (existItem) quantity = existItem.QUANTITY + 1;
      }

      const res = await this.cartService.add({ID: idProduct, QUANTITY: quantity});
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    } finally {
      this.loadingState = false;
    }
  }

  public async addToCompare(item: CatalogItem) {
    this.loadingState = true;
    try {
      const res = await this.compareService.add(item.ID);
      this.items.find((i) => i.ID === item.ID).IS_IN_COMPARE = true;
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    } finally {
      this.loadingState = false;
    }
  }

  public async removeFromCompare(item: CatalogItem) {
    this.loadingState = true;
    try {
      const res = await this.compareService.delete(item.ID);
      this.items.find((i) => i.ID === item.ID).IS_IN_COMPARE = false;
      this.consult.notification({
        name: res.message,
        status: 'success',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
      this.error = false;
    } catch (e) {
      this.error = true;
      this.consult.notification({
        name: e.message,
        status: 'danger',
        createdAt: (new Date()).toISOString(),
        isReaded: false
      });
    } finally {
      this.loadingState = false;
    }
  }
}
